module.exports = require("./ee-TG.d.ts");